import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";
import { useToast } from "../components/toast/ToastProvider";
import { createComment, deleteComment, fetchAllComment, updateComment } from "../service/CommentService";
import CommentForm from "../components/admin/CommentForm";
import CommentList from "../components/admin/CommentList";
import Main from "../components/admin/Main";


const Comment = () => {
  const [comment, setComment] = useState([]);
  const [selectedComment, setSelectedComment] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const loadComments = async () => {
    try {
      setLoading(true);
      const res = await fetchAllComment();

      setComment(res);
    } catch (error) {
      toast("Error in fetch Comment", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadComments();
  }, []);
  const handleSave = async (adData) => {
    try {
      const postData = {
        postId: adData.postId,
        userId: adData.userId,
        content: adData.content,

      };

      if (selectedComment) {
        await updateComment(selectedComment.commentId, postData);
        toast("Comment Updated", "SUCCESS");
      } else {
        await createComment(postData);
        toast("Comment Added", "SUCCESS");
      }

      setShowModal(false);
      setSelectedComment(null);
      setViewMode(false);
      await loadComments();
    } catch (error) {
      toast("Error saving Comment", "ERROR");
    }
  };

  const handleEdit = (ad) => {
    setSelectedComment(ad);
    setViewMode(false);
    setShowModal(true);
  };

  const handleView = (ad) => {
    setSelectedComment(ad);
    setViewMode(true);
    setShowModal(true);
  };

  const handleDelete = async (commentId) => {
    if (window.confirm("Are you sure you want to delete this ad?")) {
      await deleteComment(commentId);
      toast("Comment Deleted", "SUCCESS");
      await loadComments();
    } else {
      toast("Error in delete Comment", "ERROR");
    }
  };

  return (
    <Main>
      <PageContainer
        title="Comment"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedComment(null);
          setViewMode(false);
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedComment(null);
            setViewMode(false);
          }}
          headerText={
            viewMode
              ? "View Comment"
              : selectedComment
                ? "Edit Comment"
                : "Add Comment"
          }
          centered
        >
          <CommentForm
            initialData={selectedComment}
            readOnly={viewMode}
            onSave={handleSave}
            loading={loading}
            setLoading={setLoading}
          />

          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => {
                  setLoading(true);
                  setTimeout(() => {
                    setViewMode(false);
                    setLoading(false);
                  }, 200);
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Loading...
                  </>
                ) : (
                  "Edit"
                )}
              </button>
            </div>
          )}
        </Modal>

        <CollapseCard title="Comment List">
          <CommentList
            comment={comment}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onView={handleView}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default Comment;
